import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";
import { Trash2, Globe } from "lucide-react";

export default function Settings() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [busy, setBusy] = useState(false);

  async function del() {
    if (!window.confirm(t("settings.confirmDelete"))) return;
    setBusy(true);
    try {
      await api.delete("/me/data");
      toast.success(t("settings.deleted"));
      logout();
      window.location.href = "/";
    } catch { toast.error(t("errors.generic")); }
    finally { setBusy(false); }
  }

  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{t("settings.title")}</h1>

      <div className="hb-card p-6 mt-6">
        <div className="flex items-center gap-2 mb-2">
          <Globe className="w-5 h-5 text-blue-600" />
          <div className="font-adult font-semibold text-slate-900">{t("common.language")}</div>
        </div>
        <p className="text-sm text-slate-600 mb-4">{t("language.chooseSubtitle")}</p>
        <LanguageSwitcher variant="grid" />
      </div>

      <div className="hb-card p-6 mt-6 border-red-200">
        <div className="text-red-700 font-semibold">{t("settings.deleteAccount")}</div>
        <p className="text-sm text-slate-600 mt-1">{t("settings.deleteBody")}</p>
        <Button variant="destructive" className="mt-3 rounded-full" onClick={del} disabled={busy} data-testid="settings-delete">
          <Trash2 className="w-4 h-4 mr-1" /> {busy ? t("settings.deleting") : t("settings.deleteButton")}
        </Button>
      </div>
    </AppShell>
  );
}
